import type { Avatar as AvatarType } from '@jotta/types/Avatar'
import { Avatar } from '@jotta/ui/Avatar'
import { t } from '@lingui/macro'
import { AnimatePresence, motion } from 'framer-motion'
import { forwardRef, useContext } from 'react'
import { CommentsContext } from './CommentsContext'
import type { TextareaRef } from './TextArea'
import { Textarea } from './TextArea'

export const ReplyField = forwardRef<
  TextareaRef,
  {
    show?: boolean
    fullName: string
    avatar: AvatarType
    onSubmit?: (text: string) => void
  }
>(function ReplyField({ show = false, fullName, avatar, onSubmit }, ref) {
  const { darkMode } = useContext(CommentsContext)
  // const ref = useRef<TextareaRef>(null)

  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          sx={{
            py: '5px',
            px: '7px',
            backgroundColor: darkMode ? '#212121' : 'lightGray',
            border: '1px solid',
            borderColor: darkMode ? '#191919' : 'gray',
            borderRadius: '20px',
            display: 'flex',
            flexWrap: 'nowrap',
            overflow: 'hidden',
          }}
          initial={{ height: 0, marginTop: 0, marginBottom: 0 }}
          exit={{ height: 0, marginTop: 0, marginBottom: 0 }}
          animate={{ height: 'auto', marginTop: 8, marginBottom: 24 }}
          transition={{ duration: 0.2 }}
        >
          <Avatar avatar={avatar} size={24} sx={{ mr: 2 }} />
          <Textarea
            ref={ref}
            sx={{
              resize: 'none',
              overflow: 'hidden',
              border: 0,
              fontSize: 2,
              flex: '1 1 auto',
            }}
            placeholder={t`Comments.writeReply`}
            onSubmit={onSubmit}
          />
        </motion.div>
      )}
    </AnimatePresence>
  )
})
